import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [message, setMessage] = useState("Menyelesaikan login...");

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = hash.get("session_id");
    if (!sessionId) {
      setMessage("Session login tidak ditemukan.");
      return;
    }

    api.post("/auth/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        setMessage("Login Google gagal. Coba lagi atau gunakan email dan password.");
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="auth-callback">
      <div className="text-center">
        <Logo size={56} className="mx-auto rounded-xl mb-4" />
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
